import { render, staticRenderFns } from "./StatOverview.vue?vue&type=template&id=05b130b5&scoped=true"
import script from "./StatOverview.vue?vue&type=script&lang=js"
export * from "./StatOverview.vue?vue&type=script&lang=js"
import style0 from "./StatOverview.vue?vue&type=style&index=0&id=05b130b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b130b5",
  null
  
)

export default component.exports